export default __webpack_public_path__ + "static/party_mix-a51e97a7e582a5246fbf1f2b802b8ada.png";